function cov_pkpa934gf() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Open.tsx";
  var hash = "891efd674c67c3ed84826d37d28ff7882e06c4dd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Open.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "891efd674c67c3ed84826d37d28ff7882e06c4dd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_pkpa934gf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_pkpa934gf();
var Icon = (cov_pkpa934gf().s[0]++, {
  name: 'open',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 6C1.79086 6 0 7.79086 0 10V14.5217C0 16.7309 1.79086 18.5217 4 18.5217H20C22.2091 18.5217 24 16.7309 24 14.5217V10C24 7.79086 22.2091 6 20 6H4ZM6.04506 12.2715C6.04506 13.1776 5.59684 13.7298 4.87826 13.7298C4.17391 13.7298 3.70435 13.1989 3.70435 12.2786V12.2219C3.70435 11.3016 4.15257 10.7849 4.87115 10.7849C5.58972 10.7849 6.04506 11.3158 6.04506 12.2149V12.2715ZM2.6087 12.2856C2.6087 13.8077 3.20632 14.8696 4.8498 14.8696C6.49328 14.8696 7.14071 13.8077 7.14071 12.2503V12.1936C7.14071 10.622 6.42213 9.65217 4.87115 9.65217C3.34862 9.65217 2.6087 10.6857 2.6087 12.229V12.2856ZM7.85217 14.0625C7.85217 14.4613 8.17708 14.7846 8.57786 14.7846C8.97865 14.7846 9.30356 14.4613 9.30356 14.0625V13.0785H9.85138C11.1107 13.0785 11.8292 12.5051 11.8292 11.4432V11.4149C11.8292 10.3389 11.1818 9.72297 9.78735 9.72297H8.83675C8.29298 9.72297 7.85217 10.1616 7.85217 10.7026V14.0625ZM9.72332 12.0874H9.30356V10.8132H9.73043C10.1858 10.8132 10.4419 10.9901 10.4419 11.422V11.4503C10.4419 11.868 10.1929 12.0874 9.72332 12.0874ZM12.4909 14.0858C12.4909 14.4718 12.8053 14.7846 13.1932 14.7846H15.5573C15.8677 14.7846 16.1194 14.5342 16.1194 14.2254C16.1194 13.9165 15.8677 13.6661 15.5573 13.6661H13.9423V12.7458H15.0664C15.3532 12.7458 15.5858 12.5144 15.5858 12.229C15.5858 11.9436 15.3532 11.7122 15.0664 11.7122H13.9423V10.8415H15.4435C15.7539 10.8415 16.0055 10.5911 16.0055 10.2822C16.0055 9.97336 15.7539 9.72297 15.4435 9.72297H13.1712C12.7955 9.72297 12.4909 10.026 12.4909 10.3998V14.0858ZM16.8451 14.1475C16.8451 14.4994 17.1317 14.7846 17.4854 14.7846C17.839 14.7846 18.1257 14.4994 18.1257 14.1475V11.606L19.724 14.342C19.8841 14.616 20.1786 14.7846 20.4971 14.7846C20.991 14.7846 21.3913 14.3863 21.3913 13.8949V10.3566C21.3913 10.0066 21.1062 9.72297 20.7545 9.72297C20.4029 9.72297 20.1178 10.0066 20.1178 10.3566V12.5759L18.7872 10.246C18.6026 9.92269 18.2577 9.72297 17.884 9.72297C17.3102 9.72297 16.8451 10.1858 16.8451 10.7567V14.1475Z\" fill=\"currentColor\"/>"
});
export default Icon;